export const faqData = [
  {
    question: "What is Archinza all about?",
    answer: {
      text: `Archinza is an AI-powered discovery platform built for the Design & Build industry.
It streamlines how professionals and clients find products, materials, and expertise instantly on demand.
At its core, Archinza enhances visibility and discovery across the entire design spectrum starting with a mobile-first WhatsApp interface for real-time answers and extending to the Archinza Web platform for matchmaking.`,
    },
  },
  {
    question: "Who is Archinza for?",
    answer: {
      text: `Archinza is designed for anyone in the Design & Build industry.
Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.`,
    },
  },
  {
    question: 'What is the "Ask" feature in Archinza?',
    answer: {
      text: `The Ask feature (available on WhatsApp) is powered by AI and provides instant, relevant answers to your queries about design, construction, and professional guidance.
In the currently available Beta version of Archinza, you can ask about technical details, materials suggestions, methods, project tips, or even mentorship.
After the full product, you will be able to get matchmade recommendations for vendors / consultants / designers or execution teams. </br>
Please note: Archinza AI™ is a model in development, doing its best to provide helpful responses in real time and continuously learning to improve.`,
    },
  },
  {
    question: "How will Archinza benefit me?",
    answer: {
      text: "Here’s how Archinza can help you:",
      list: [
        "Quick, real-time answers to design or construction-related questions.",
        "Smarter search for products, materials, inspirations, and services across the industry.",
        "Expanded visibility for your offerings or expertise, helping you reach the right audience.",
        "Curated resources to stay updated on trends, upskilling, and industry developments.",
        "It’s like having a design-savvy assistant for anyone searching, showcasing, building in the Design & Build industry.",
      ],
    },
  },
  {
    question: "Where do I sign up?",
    answer: {
      text: `Sign up via WhatsApp or the Archinza Web platform to get started.<a href="/register"> Click here </a>  to be a part of the Archinza Network.`,
    },
  },
  {
    question: "What can I do on Archinza?",
    answer: {
      text: "With a Business Account you can:",
      list: [
        "Showcase your products, materials, and services to the right audience.",
        "Reach potential clients, or industry professionals instantly.",
        "Get discovered through AI-powered search and matchmaking.",
        "Access insights to understand what users are searching for and trending in the industry.",
      ],
      extraText: "With a Personal Account you can:",
      extraList: [
        "Search for products, materials, services, and professionals across the Design & Build ecosystem.",
        "Ask questions and get real-time answers, from design guidance to technical queries.",
        "Explore curated resources, industry updates, business reviews, and AI-matched upskilling courses.",
        "Discover relevant businesses and professionals to support your projects or interests.",
      ],
    },
  },
  {
    question: "Is Archinza free?",
    answer: {
      text: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch.  </br></br>
      For Businesses
        </br>
      We're also offering exclusive free access to our first 1000 business users for the STARTER Plan features —no charges. While the SUPPORTER Plan is available at ₹2499
`,
    },
  },
  {
    question: "How can I edit my business name or details on Archinza?",
    answer: {
      text: `You can update your information anytime from your Dashboard. Simply log in, go to your dashboard, and make the changes.`,
    },
  },
  {
    question:
      "How can I change, upgrade, or cancel my Archinza subscription?",
    answer: {
      text: `You can update your Archinza subscription anytime from your dashboard. Simply click on your Profile Icon in the top-right corner, then select ‘Your Plan’ from the dropdown menu.
There, you’ll see a full overview of your current subscription. Click on ‘Manage Plan’ to upgrade, downgrade, cancel, or switch between monthly and yearly billing.
`,
      list: ["🛠 Need help choosing the right plan?"],
    },
  },
];

const listToHtml = (items) =>
  `<ul>${items.map((li) => `<li>${li}</li>`).join("")}</ul>`;

export const faqDataForAccordion = faqData.map((item) => {
  const parts = [];
  if (item.answer.text) parts.push(item.answer.text);
  if (item.answer.list && item.answer.list.length)
    parts.push(listToHtml(item.answer.list));
  if (item.answer.extraText) parts.push(item.answer.extraText);
  if (item.answer.extraList && item.answer.extraList.length)
    parts.push(listToHtml(item.answer.extraList));
  return {
    title: item.question,
    content: parts.join(""),
  };
});
